import { useAutomationWorkoutsQuery } from 'generated/graphql';

import type { Async } from '@client/new/helpers/types';
import { makeAsync } from '@client/new/helpers/async';

/** A published workout the creator can point the trial sequence at. The id
 *  is a string because the config draft keeps ids as typed text. */
export type WorkoutOption = { id: string; name: string };

export const useAutomationWorkoutsModel = (
  creatorId: number,
  searchTerm: string,
): Async<WorkoutOption[], { message: string; retry: () => Promise<void> }> => {
  const query = useAutomationWorkoutsQuery({
    variables: {
      influencerId: creatorId,
      searchTerm: searchTerm.trim() || undefined,
    },
    fetchPolicy: 'cache-first',
  });

  if (query.error) {
    return makeAsync.error({
      message: query.error.message,
      retry: async () => {
        await query.refetch();
      },
    });
  }
  if (query.loading && !query.data) return makeAsync.fetching();
  if (!query.data) return makeAsync.notFetched();
  return makeAsync.fetched(
    query.data.workouts.map((workout) => ({
      id: String(workout.id),
      name: workout.name ?? `Workout #${workout.id}`,
    })),
  );
};
